<template>
  <div>
  
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="addRecord">
      新增支付配置
    </a-button>
    <div>
        <div>
            <span>汇付公钥、秘钥获取请登录汇付天下商户平台，在秘钥管理中生成，切不可外露：</span>
            <a href="https://dashboard.huifu.com/customers/login" target="_blank" >点击此处跳转</a>
        </div>
    </div>
    <a-table
      :columns="columns"
      :row-key="record => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="shelf" slot-scope="text, record">
        <a-switch
          :checked="record.shelf"
          checked-children="上架"
          un-checked-children="下架"
          @change="toggleShelf(record)"
        />
      </template>
      <template slot="operate" slot-scope="text, record">
        <a href="javascript:;" @click="editRecord(record)">编辑</a>
        <a-divider type="vertical" />
        <a href="javascript:;" @click="delRecord(record)">删除</a>
      </template>
    </a-table>

    <!-- 新增/编辑弹窗 -->
    <a-modal v-model="visible" :title="modalTitle" @ok="handleOk" width="640px">
      <a-form :label-col="{ span: 7 }" :wrapper-col="{ span: 15 }">
        <a-form-item label="门店编号" v-if="modalTitle === '新增支付配置'">
          <a-input v-model="form.shopNo" placeholder="门店编号" />
        </a-form-item>
        <a-form-item label="渠道商商户号">
          <a-input v-model="form.sysId" placeholder="请输入渠道商商户号" />
        </a-form-item>
        <a-form-item label="产品id">
          <a-input v-model="form.productId" placeholder="请输入付汇产品id" />
        </a-form-item>
        <a-form-item label="汇付商户号">
          <a-input v-model="form.huifuPayId" placeholder="请输入汇付商户号" />
        </a-form-item>
        <a-form-item label="微信小程序APPID">
          <a-input v-model="form.wxSmallAppId" placeholder="请输入微信小程序ID" />
        </a-form-item>
        <a-form-item label="汇付公钥">
          <a-textarea v-model="form.publicKey" :rows="6" placeholder="请输入汇付公钥" />
        </a-form-item>
        <a-form-item label="私钥">
          <a-textarea v-model="form.privateKey" :rows="6" placeholder="请输入私钥" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {
  getHuiFuPayList,
  addHuiFuPay,
  deleteHuiFuPay,
  onShelfHuiFuPay,
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  { title: "ID", dataIndex: "objId", align: "center", width: 80 },
  { title: "门店名称", dataIndex: "shopName", align: "center", width: 150 },
  { title: "渠道商商户号", dataIndex: "sysId", align: "center", width: 150 },
  { title: "产品id", dataIndex: "productId", align: "center", width: 150 },
  { title: "汇付商户号", dataIndex: "huifuPayId", align: "center" },
  { title: "微信小程序ID", dataIndex: "wxSmallAppId", align: "center" },
  {
    title: "状态",
    dataIndex: "shelf",
    align: "center",
    scopedSlots: { customRender: "shelf" },
    width: 120
  },
  {
    title: "操作",
    dataIndex: "operate",
    align: "center",
    width: 150,
    scopedSlots: { customRender: "operate" }
  }
];

export default {
  props: ["formInline"],
  data() {
    return {
      data: [],
      loading: false,
      columns,
      visible: false,
      modalTitle: "新增支付配置",
      form: this.initForm(),
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      checkedPay: false,
    };
  },
  mounted() {
    this.getData();
  },
  props: ["formInline"],
  methods: {
    initForm() {
      return {
        huifuPayId: "",
        wxSmallAppId: "",
        publicKey: "",
        privateKey: "",
        shelf: false,
        sysId: "",
        productId: "",
      };
    },
    getData() {
      this.loading = true;
      this.data = [];
      getHuiFuPayList({
        huifuPayId: this.formInline.huifuPayId,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        shopNo: this.formInline.shopNo || '',
      }).then(res => {
        this.loading = false;
        if (res.success && res.data) {
          this.data = res.data.data;
          this.pagination.total = res.data.data.count || this.data.data.length;
        } else {
          this.data = [];
          message.info("暂无数据");
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    addRecord() {
      this.modalTitle = "新增支付配置";
      this.form = this.initForm();
      this.visible = true;
    },
    editRecord(row) {
      this.modalTitle = "编辑支付配置";
      this.form = {
        objId: row.objId,
        huifuPayId: row.huifuPayId.trim() || "",
        wxSmallAppId: row.wxSmallAppId.trim() || "",
        publicKey: row.publicKey.trim() || "",
        privateKey: row.privateKey.trim() || "",
        shopId: row.shopId || null,
        shelf: row.shelf || false,
        sysId:row.sysId.trim() || "",
        productId: row.productId.trim() || "",

      };
      this.visible = true;
    },
    handleOk() {
      if (!this.form.huifuPayId) {
        message.warning("汇付商户号不能为空");
        return;
      }
      if (!this.form.shopNo && this.modalTitle === '新增支付配置') {
        message.warning("门店编号不能为空");
        return;
      }
      const params = { ...this.form };
      this.visible = false;
      addHuiFuPay(params).then(res => {
        message.success(res.info || "操作成功");
        this.getData();
      }).catch(() => {
        message.error("操作失败");
      });
    },
    delRecord(row) {
      const self = this;
      this.$confirm({
        title: "确认删除",
        content: `确定要删除该支付配置（商户号：${row.huifuPayId}）吗？`,
        onOk() {
          return deleteHuiFuPay(row.objId).then(res => {
            message.success(res.info || "删除成功");
            self.getData();
          });
        }
      });
    },
    toggleShelf(row) {
      onShelfHuiFuPay(row.objId, !row.shelf).then(res => {
        message.success(res.info || "操作成功");
        this.getData();
      }).catch(() => {
        message.error("操作失败");
      });
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/storeManagement/huifuPayManagement/payManagementAdmin/payContent.vue